export default __webpack_public_path__ + "static/media/42.0bcf6f83.svg";